import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';

let styles;
const walkingIcon = require('./icons/walking.svg');
const runningIcon = require('./icons/running.svg');
const swimmingIcon = require('./icons/swimming.svg');

const beachIcon = require('./icons/beach.svg');
const parksIcon = require('./icons/parks.svg');
const cafesIcon = require('./icons/cafes.svg');
const homeHangsIcon = require('./icons/home.svg');
const adventuresIcon = require('./icons/adventures.svg');
const trainingIcon = require('./icons/training.svg');
const agilityIcon = require('./icons/agility.svg');
const serviceWorkIcon = require('./icons/service.svg');
const therapyWorkIcon = require('./icons/therapy.svg');
const dogTimeIcon = require('./icons/dogTime.svg');

export default class ActivityBadge extends Component {
  constructor(props) {
    super(props);

    this.icons = {
      running: runningIcon,
      walking: walkingIcon,
      beach: beachIcon,
      swimming: swimmingIcon,
      parks: parksIcon,
      cafes: cafesIcon,
      'home hangs': homeHangsIcon,
      adventures: adventuresIcon,
      training: trainingIcon,
      agility: agilityIcon,
      'service work': serviceWorkIcon,
      'therapy work': therapyWorkIcon,
      'dog time': dogTimeIcon,
      'dog friends': dogTimeIcon,
    };
  }

  render() {
    const iconSource = this.icons[this.props.activity.toLowerCase()];

    return (
      <div
        className={css(
          styles.badge,
          this.props.label ? styles.badge_lg : null,
          this.props.styles,
        )}>
        <img src={iconSource} className={css(styles.badge_icon)} alt={`${this.props.activity}`} />
        {this.props.label ? <div className={css(styles.label)}>{this.props.activity}</div> : null}
      </div>
    );
  }
}

ActivityBadge.defaultProps = {
  label: false,
  styles: null,
};

ActivityBadge.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  activity: PropTypes.string.isRequired,
  label: PropTypes.bool,
};

styles = StyleSheet.create({
  badge: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 42,
    width: 42,

    ':not(:last-child)': {
      marginRight: 10,
    },

    ':after': {
      position: 'absolute',
      top: -1,
      left: -1,
      height: 44,
      width: 44,
      boxShadow: '0 0 0 2px #fff inset',
      borderRadius: '50%',
      content: '""',
    },
  },
  badge_lg: {
    height: 58,
    width: 58,

    ':after': {
      height: 60,
      width: 60,
    },
  },
  label: {
    marginTop: 10.4,
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  badge_icon: {
    flexShrink: 0,
    display: 'block',
    height: '100%',
    width: '100%',
    borderRadius: '50%',
    backgroundColor: '#000e1f',
  },
});



// WEBPACK FOOTER //
// ./src/components/ActivityBadge/index.js